<template>
  <div>
    <div class="case-spisi case-naplata">
      <div class="spisi-left">
        <div class="case-spisi-folders-line naplata-folders-line">
          <div :class="['troskovnici-button','active']" >
            <div>{{$t("billing_page.naplata_tabs.t1")}}</div>
            <svg xmlns="http://www.w3.org/2000/svg" width="13" height="15" viewBox="0 0 13 15" fill="none">
              <path
                d="M3.54545 3.85135C3.54545 3.5155 3.81001 3.24324 4.13636 3.24324H9.65152C9.97787 3.24324 10.2424 3.5155 10.2424 3.85135C10.2424 4.1872 9.97787 4.45946 9.65152 4.45946H4.13636C3.81001 4.45946 3.54545 4.1872 3.54545 3.85135Z"
                fill="#2A306B" />
              <path
                d="M4.13636 5.67568C3.81001 5.67568 3.54545 5.94793 3.54545 6.28378C3.54545 6.61963 3.81001 6.89189 4.13636 6.89189H8.07576C8.40211 6.89189 8.66667 6.61963 8.66667 6.28378C8.66667 5.94793 8.40211 5.67568 8.07576 5.67568H4.13636Z"
                fill="#2A306B" />
              <path fill-rule="evenodd" clip-rule="evenodd"
                d="M3.74242 0C1.67554 0 0 1.72431 0 3.85135V11.9595C0 13.6387 1.32279 15 2.95455 15H11.6212C12.3827 15 13 14.3647 13 13.5811V1.41892C13 0.635272 12.3827 0 11.6212 0H3.74242ZM11.8182 8.91892V1.41892C11.8182 1.30697 11.73 1.21622 11.6212 1.21622H3.74242C2.32824 1.21622 1.18182 2.39601 1.18182 3.85135V9.5268C1.67562 9.1451 2.28941 8.91892 2.95455 8.91892H11.8182ZM11.8182 10.1351H2.95455C1.9755 10.1351 1.18182 10.9519 1.18182 11.9595C1.18182 12.967 1.9755 13.7838 2.95455 13.7838H11.6212C11.73 13.7838 11.8182 13.693 11.8182 13.5811V10.1351Z"
                fill="#2A306B" />
            </svg>
          </div>
          <div :class="['izdani-racuni-button']"  @click="switchTab('izdane-fakture')">
            <div>{{$t("billing_page.naplata_tabs.t2")}}</div>
            <svg xmlns="http://www.w3.org/2000/svg" width="13" height="15" viewBox="0 0 13 15" fill="none">
              <path fill-rule="evenodd" clip-rule="evenodd"
                d="M3.74242 0C1.67554 0 0 1.72431 0 3.85135V11.9595C0 13.6387 1.32279 15 2.95455 15H11.6212C12.3827 15 13 14.3647 13 13.5811V1.41892C13 0.635272 12.3827 0 11.6212 0H3.74242ZM11.8182 8.91892V1.41892C11.8182 1.30697 11.73 1.21622 11.6212 1.21622H3.74242C2.32824 1.21622 1.18182 2.39601 1.18182 3.85135V9.5268C1.67562 9.1451 2.28941 8.91892 2.95455 8.91892H11.8182ZM11.8182 10.1351H2.95455C1.9755 10.1351 1.18182 10.9519 1.18182 11.9595C1.18182 12.967 1.9755 13.7838 2.95455 13.7838H11.6212C11.73 13.7838 11.8182 13.693 11.8182 13.5811V10.1351Z"
                fill="#2A306B" />
              <g clip-path="url(#clip0_706_32)">
                <path
                  d="M7.54927 7.13067C6.92284 7.13067 6.37402 6.70904 6.07594 6.08176H8.04732V5.21245H5.84683C5.84135 5.14213 5.8384 5.07169 5.8384 4.99975C5.8384 4.92848 5.84133 4.85718 5.84683 4.7878H8.04736V3.91832H6.07596C6.37404 3.2911 6.92284 2.8696 7.54929 2.8696C8.14803 2.8696 8.71183 3.27042 9.02057 3.91517L9.80498 3.54025C9.35025 2.58994 8.48598 2 7.54927 2C6.8451 2 6.18785 2.32177 5.69857 2.90683C5.45248 3.20114 5.26446 3.54455 5.14085 3.91832H4.19531V4.78778H4.97517C4.97098 4.85762 4.96882 4.92895 4.96882 4.99973C4.96882 5.07125 4.97098 5.14166 4.97517 5.21243H4.19531V6.08174H5.14085C5.26446 6.45547 5.45248 6.79849 5.69859 7.09254C6.18787 7.67763 6.84512 8 7.54929 8C8.48602 8 9.35025 7.41014 9.80498 6.45985L9.02057 6.08423C8.71181 6.72982 8.14801 7.13067 7.54927 7.13067Z"
                  fill="#2A306B" />
              </g>
              <defs>
                <clipPath id="clip0_706_32">
                  <rect width="6" height="6" fill="white" transform="translate(4 2)" />
                </clipPath>
              </defs>
            </svg>
          </div>
        </div>
        <div class="opening-folder">
          <div class="open-folder-line">
            <div class="open-folder-line-left">
              <div class="open-folder-icon-text-row">
                <div class="folder-tiny-icon">
                  <img src="@/assets/img/tiny-folder.png" />
                </div>
                <div class="folder-open-name">
                  {{$t("billing_page.naplata_title")}}
                </div>
              </div>
              <div class="naplata-filters">
                <v-menu ref="menu1" v-model="menu1" :close-on-content-click="false" transition="scale-transition"
                  offset-y min-width="auto">
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field v-model="dateRangeText" readonly clearable :label="$t('billing_page.filters.f1')"
                      append-icon="mdi-calendar" v-bind="attrs" @click:append="menu1 = !menu1" v-on="on"
                      class="case-date-picker rocista-date-picker"></v-text-field>
                  </template>
                  <v-date-picker locale="hr" :first-day-of-week="1" v-model="date_range" range no-title :pickerDate.sync="pickerDate">
                  </v-date-picker>
                </v-menu>
                <CustomDropdown :id="'drop_types'" class="wider" :additional_classes="'phase'" v-model="selektirani_tip"
                  :drop_items="filter_type" :init_text="$t('billing_page.filters.f2')" />
                <CustomDropdown :id="'drop_odvjetnici'" class="wider" :additional_classes="'phase'"
                  v-model="selektirana_osoba" :drop_items="all_odvjetnici" :init_text="$t('billing_page.filters.f3')" />
                <CustomDropdown :id="'drop_foldery_types'" class="wider" :additional_classes="'phase'"
                  v-model="selektirani_tip_foldera" :drop_items="all_doc_types" :init_text="$t('billing_page.filters.f4')" />
                <!-- <div class="generiraj-rocisnik-button" @click="openReport()">
                        <svg xmlns="http://www.w3.org/2000/svg" width="21" height="22" viewBox="0 0 21 22" fill="none"><path d="M5.24463 13.7815L8.23776 9.89137L11.652 12.5733L14.581 8.79297" stroke="#2B2B41" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path><circle cx="17.9954" cy="3.20027" r="1.9222" stroke="#2B2B41" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></circle><path d="M12.9243 2.12024H5.65655C2.64511 2.12024 0.777832 4.25296 0.777832 7.2644V15.3468C0.777832 18.3582 2.6085 20.4818 5.65655 20.4818H14.2607C17.2721 20.4818 19.1394 18.3582 19.1394 15.3468V8.30788" stroke="#2B2B41" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path></svg>
                        <span>Izvještaj</span>
                      </div> -->
              </div>
            </div>

          </div>
          <div class="open-folder-line sort-buttons">
            <div class="open-folder-line-right">
              <div class="open-folder-line-sort svg-name" @click="reverseSmjer(0)" id="name-filter">
                {{ $t('page_2.page_2_7.f1') }} {{ order_by_tekst }}
                <svg v-if="smjer" xmlns="http://www.w3.org/2000/svg" width="45" height="20" viewBox="0 0 45 20"
                  class="svg-name-to-rotate">
                  <path
                    d="M4.1448 12.8692H5.3L5.3 3.52032C5.3009 3.44154 5.3317 3.36634 5.38566 3.31117C5.43963 3.25599 5.51236 3.22534 5.58795 3.22591H7.91198C7.94949 3.22544 7.98672 3.23269 8.02155 3.24724C8.05637 3.26179 8.08809 3.28336 8.1149 3.31071C8.14171 3.33805 8.16309 3.37065 8.17779 3.40662C8.1925 3.44258 8.20025 3.48122 8.20061 3.52032L8.20061 12.8692H9.35445C9.40849 12.8689 9.46151 12.8845 9.50748 12.9141C9.55345 12.9436 9.59053 12.9861 9.61449 13.0366C9.63801 13.0865 9.64718 13.1425 9.6409 13.1977C9.63462 13.253 9.61316 13.3052 9.57909 13.348L6.97461 17.3109C6.94717 17.3451 6.9128 17.3726 6.87396 17.3914C6.83512 17.4102 6.79278 17.4197 6.74997 17.4194C6.66283 17.4194 6.57978 17.3797 6.52532 17.3102L5.22308 15.3287L3.92084 13.3473C3.88678 13.3045 3.86531 13.2523 3.85903 13.197C3.85275 13.1418 3.86192 13.0858 3.88544 13.0359C3.9094 12.9854 3.94648 12.9429 3.99245 12.9133C4.03842 12.8837 4.09144 12.8682 4.14548 12.8684L4.1448 12.8692Z"
                    fill="#3326AE" />
                  <path
                    d="M13.4579 16.2903H11.9806L16.2534 4.65392H17.7079L21.9806 16.2903H20.5034L17.0261 6.49483H16.9352L13.4579 16.2903ZM14.0034 11.7448H19.9579V12.9948H14.0034V11.7448ZM28.6113 9.8471V11.0971H23.5204V9.8471H28.6113ZM30.7661 16.2903V15.2676L37.0389 5.90392H30.698V4.65392H38.7207V5.67665L32.448 15.0403H38.7889V16.2903H30.7661Z"
                    fill="#3326AE" />
                </svg>

                <svg v-else xmlns="http://www.w3.org/2000/svg" width="45" height="20" viewBox="0 0 45 20">
                  <path
                    d="M9.3552 7.77611H8.2V17.1249C8.1991 17.2037 8.1683 17.2789 8.11434 17.3341C8.06037 17.3893 7.98764 17.4199 7.91205 17.4194H5.58802C5.55051 17.4198 5.51328 17.4126 5.47845 17.398C5.44363 17.3835 5.41191 17.3619 5.3851 17.3346C5.35829 17.3072 5.33691 17.2746 5.32221 17.2386C5.3075 17.2027 5.29975 17.164 5.29939 17.1249V7.77611H4.14555C4.09151 7.77637 4.03849 7.76081 3.99252 7.73121C3.94655 7.70161 3.90947 7.65916 3.88551 7.60868C3.86199 7.55873 3.85282 7.50277 3.8591 7.44752C3.86538 7.39227 3.88684 7.34008 3.92091 7.29724L6.52539 3.33438C6.55283 3.30013 6.5872 3.27263 6.62604 3.25387C6.66488 3.2351 6.70722 3.22553 6.75003 3.22584C6.83717 3.22584 6.92022 3.26557 6.97468 3.33509L8.27692 5.31652L9.57916 7.29795C9.61322 7.34079 9.63469 7.39298 9.64097 7.44823C9.64725 7.50348 9.63808 7.55944 9.61456 7.60939C9.5906 7.65987 9.55352 7.70232 9.50755 7.73192C9.46158 7.76152 9.40856 7.77708 9.35452 7.77682L9.3552 7.77611Z"
                    fill="#3326AE" />
                  <path
                    d="M13.4579 16.2903H11.9806L16.2534 4.65392H17.7079L21.9806 16.2903H20.5034L17.0261 6.49483H16.9352L13.4579 16.2903ZM14.0034 11.7448H19.9579V12.9948H14.0034V11.7448ZM28.6113 9.8471V11.0971H23.5204V9.8471H28.6113ZM30.7661 16.2903V15.2676L37.0389 5.90392H30.698V4.65392H38.7207V5.67665L32.448 15.0403H38.7889V16.2903H30.7661Z"
                    fill="#3326AE" />
                </svg>
              </div>
              <div class="open-folder-line-sort active" @click="reverseSmjer(1)" id="date-filter">
                {{ $t('page_2.page_2_7.f2') }} {{ order_by_tekst }}
                <svg width="20" height="20" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"
                  class="svg-to-rotate">
                  <g clip-path="url(#clip0_1212_3564)">
                    <path
                      d="M10.2379 8.31799H4.57294C4.43494 8.31799 4.32294 8.20899 4.32294 8.07399V5.15899C4.3232 5.12647 4.32988 5.09432 4.3426 5.06438C4.35531 5.03445 4.37382 5.00732 4.39705 4.98456C4.42027 4.9618 4.44777 4.94384 4.47795 4.93173C4.50814 4.91962 4.54041 4.91359 4.57294 4.91399H10.2379C10.2705 4.91359 10.3027 4.91962 10.3329 4.93173C10.3631 4.94384 10.3906 4.9618 10.4138 4.98456C10.4371 5.00732 10.4556 5.03445 10.4683 5.06438C10.481 5.09432 10.4877 5.12647 10.4879 5.15899V8.07399C10.4879 8.20899 10.3759 8.31799 10.2379 8.31799ZM10.2379 3.42299H7.03693C6.89893 3.42299 6.78693 3.31299 6.78693 3.17799V0.262991C6.7872 0.230469 6.79388 0.198318 6.80659 0.168385C6.81931 0.138451 6.83782 0.111326 6.86104 0.088562C6.88427 0.0657983 6.91177 0.0478466 6.94195 0.0357361C6.97214 0.0236256 7.00441 0.0175941 7.03693 0.0179901H10.2369C10.2695 0.0175941 10.3017 0.0236256 10.3319 0.0357361C10.3621 0.0478466 10.3896 0.0657983 10.4128 0.088562C10.4361 0.111326 10.4546 0.138451 10.4673 0.168385C10.48 0.198318 10.4867 0.230469 10.4869 0.262991V3.17799C10.4869 3.31299 10.3769 3.42299 10.2379 3.42299ZM10.2379 14.147L2.40993 14.147C2.27194 14.147 2.15993 14.037 2.15993 13.902V10.988C2.16073 10.9224 2.18748 10.8598 2.23433 10.8139C2.28119 10.7679 2.34433 10.7425 2.40993 10.743H10.2379C10.3035 10.7425 10.3667 10.7679 10.4135 10.8139C10.4604 10.8598 10.4871 10.9224 10.4879 10.988L10.4879 13.902C10.4879 14.037 10.3759 14.147 10.2379 14.147ZM0.247934 16.572L10.2379 16.572C10.2705 16.5716 10.3027 16.5776 10.3329 16.5897C10.3631 16.6018 10.3906 16.6198 10.4138 16.6426C10.4371 16.6653 10.4556 16.6925 10.4683 16.7224C10.481 16.7523 10.4877 16.7845 10.4879 16.817V19.731C10.4879 19.866 10.3759 19.976 10.2379 19.976L0.246935 19.976C0.108935 19.976 -0.00306511 19.866 -0.00306511 19.731V16.817C-0.00280418 16.7845 0.0038762 16.7523 0.0165939 16.7224C0.0293117 16.6925 0.0478167 16.6653 0.0710449 16.6426C0.0942732 16.6198 0.121769 16.6018 0.151953 16.5897C0.182137 16.5776 0.215414 16.5716 0.247934 16.572ZM11.9209 13.586H13.6179L13.6179 0.407991C13.6193 0.296948 13.6645 0.190945 13.7438 0.113173C13.823 0.0354005 13.9299 -0.00781057 14.0409 -0.00700951H17.4549C17.51 -0.00766964 17.5647 0.00254873 17.6159 0.0230598C17.667 0.043571 17.7137 0.0739722 17.753 0.112522C17.7924 0.151072 17.8238 0.197014 17.8454 0.247715C17.867 0.298416 17.8784 0.352882 17.8789 0.407991L17.8789 13.586H19.5739C19.6533 13.5856 19.7312 13.6075 19.7987 13.6493C19.8663 13.691 19.9207 13.7508 19.9559 13.822C19.9905 13.8924 20.004 13.9713 19.9947 14.0492C19.9855 14.127 19.954 14.2006 19.9039 14.261L16.0779 19.847C16.0376 19.8953 15.9871 19.934 15.9301 19.9605C15.873 19.9869 15.8108 20.0004 15.7479 20C15.6199 20 15.4979 19.944 15.4179 19.846L11.5919 14.26C11.5419 14.1996 11.5104 14.126 11.5011 14.0482C11.4919 13.9703 11.5054 13.8914 11.5399 13.821C11.5751 13.7498 11.6296 13.69 11.6971 13.6483C11.7647 13.6065 11.8426 13.5846 11.9219 13.585L11.9209 13.586Z"
                      fill="#3326AE" />
                  </g>
                  <defs>
                    <clipPath id="clip0_1212_3564">
                      <rect width="20" height="20" fill="white" transform="translate(20 20) rotate(-180)" />
                    </clipPath>
                  </defs>
                </svg>

              </div>

            </div>

          </div>
          <div id="tree-menu" style="overflow:hidden;">
            <tree-menu style="padding-left: 1rem;" v-if="are_files_loaded" :is_editable="false" :key="refresher"
              :depth="0" :item="troskovnici_data" :accessToken="accessToken" @node-click="logClick" :smjer="smjer">
            </tree-menu>
            <custom-spinner v-else />
          </div>
          <!-- <div v-if="all_files_rec.children.length == 0 && permission.create" class="new-spis-wrapper">
                <div class="new-spis-element" @click="uploadStyling">
                <svg xmlns="http://www.w3.org/2000/svg" width="34" height="32" viewBox="0 0 42 32" fill="none">
                    <path
                    d="M33.2862 4.19414C33.3968 4.30546 33.4589 4.45603 33.4589 4.61297C33.4589 4.76991 33.3968 4.92048 33.2862 5.0318L21.2661 17.1247C20.8977 17.4965 20.4592 17.7915 19.976 17.9926C19.4928 18.1937 18.9744 18.2969 18.451 18.2962C17.9277 18.2968 17.4094 18.1936 16.9261 17.9925C16.4429 17.7914 16.0044 17.4964 15.636 17.1247L3.61674 5.03264C3.50585 4.92128 3.44359 4.77054 3.44359 4.61339C3.44359 4.45624 3.50585 4.30549 3.61674 4.19414C3.67122 4.13899 3.73611 4.09519 3.80765 4.06531C3.87919 4.03542 3.95594 4.02003 4.03347 4.02003C4.111 4.02003 4.18776 4.03542 4.2593 4.06531C4.33083 4.09519 4.39572 4.13899 4.45021 4.19414L16.4695 16.2862C16.7292 16.5474 17.038 16.7547 17.3782 16.8962C17.7183 17.0377 18.0831 17.1105 18.4515 17.1105C18.8199 17.1105 19.1846 17.0377 19.5248 16.8962C19.8649 16.7547 20.1737 16.5474 20.4335 16.2862L32.4536 4.19498C32.508 4.13995 32.5729 4.09626 32.6443 4.06645C32.7158 4.03664 32.7924 4.02129 32.8699 4.02129C32.9473 4.02129 33.024 4.03664 33.0954 4.06645C33.1669 4.09626 33.2317 4.13995 33.2862 4.19498V4.19414ZM1.17824 4.38996V22.9715C1.17824 24.7381 2.60753 26.1766 4.36402 26.1766H28.9029V27.3623H4.36402C1.95816 27.3623 0 25.3925 0 22.9715V4.38996C0 1.96904 1.95816 0 4.36402 0H32.5397C34.9456 0 36.9029 1.96987 36.9029 4.39079V19.2536H35.7255V4.39079C35.7255 2.62259 34.2962 1.18577 32.5397 1.18577H4.36402C2.60669 1.18577 1.17824 2.62343 1.17824 4.39079V4.38996ZM30.8268 26.6385C30.8268 26.2745 31.1197 25.9799 31.482 25.9799H35.5029V21.9347C35.5029 21.5715 35.7966 21.277 36.1582 21.277C36.5197 21.277 36.8126 21.5715 36.8126 21.9347V25.9799H40.8343C41.1958 25.9799 41.4887 26.2745 41.4887 26.6385C41.4887 27.0017 41.1958 27.2962 40.8343 27.2962H36.8134V31.3414C36.8134 31.7054 36.5205 32 36.159 32C36.0727 31.9998 35.9874 31.9826 35.9077 31.9494C35.8281 31.9161 35.7558 31.8676 35.695 31.8064C35.6341 31.7453 35.5859 31.6727 35.5531 31.5929C35.5203 31.5132 35.5035 31.4277 35.5038 31.3414V27.2971H31.4828C31.3088 27.2966 31.142 27.2271 31.0191 27.1038C30.8963 26.9805 30.8274 26.8134 30.8276 26.6393L30.8268 26.6385Z"
                    fill="#B8B8C1" />
                </svg>
                <span>Dodajte dokumente</span>
                </div>
            </div> -->
        </div>
      </div>
      <div class="spisi-right" v-if="activityFile != null && activityFile.folder_name != undefined">
        <div class="detalji-spisa section">
          <div class="section-title">{{ $t('page_2.page_2_3.detail_3.title') }}
            <a @click="closeDetalji()" class="entry-exit"><img src="@/assets/img/entry_form_close.svg" /></a>
          </div>
          <div class="detalji-spisa-top">
            <img class="doc-icon" src="@/assets/img/folder_icon.svg" />
            <div class="inside-folder-txts">
              <div class="inside-folder-title">{{ getFolderName(activityFile.folder_name) }}</div>
              <div class="detalji-spisa-tiny">
                <!-- <span class="tezina">{{  (activityFile.size * 0.000001).toFixed(4)  }}MB</span> -->
              </div>
            </div>
          </div>
          <div v-if="activityFile.time_created != undefined" class="detalji-spisa-list">
            <div class="detalji-spisa-middle">
              <div class="case-info-item">
                <div class="case-info-item-title">{{ $t('page_2.page_2_3.detail_3.tl_1') }}</div>
                <div class="case-info-item-info">
                  {{ switchDate(activityFile.time_created) }}
                </div>
              </div>
              <div v-if="activityFile.created_by != undefined" class="case-info-item">
                <div class="case-info-item-title">{{ $t('page_2.page_2_3.detail_3.tl_2') }}:</div>
                <div class="case-info-item-info">
                  <a href="#">{{ getOdvjetnikName(activityFile.created_by) }}</a>
                </div>
              </div>
            </div>
          </div>
          <div class="detalji-buttons">
            <div class="print-button icon-button" @click="troskovniciToPDF()">
              <svg v-if="!pdf_mergeing" xmlns="http://www.w3.org/2000/svg" width="20" height="18" viewBox="0 0 20 18">
                <g>
                  <g>
                    <path fill="#2b2b41"
                      d="M16.206 3.132H3.97a.387.387 0 0 1-.387-.387V1.738c0-.94.763-1.704 1.704-1.704h9.602c.941 0 1.704.763 1.704 1.704v1.007a.387.387 0 0 1-.387.387zM20 6.462v7.279c0 1.153-.938 2.09-2.09 2.09h-1.317v-3.097a2.79 2.79 0 0 0-2.788-2.788H6.371a2.79 2.79 0 0 0-2.788 2.788v3.098H2.267A2.093 2.093 0 0 1 .176 13.74v-7.28c0-1.152.938-2.09 2.09-2.09H17.91c1.153 0 2.091.938 2.091 2.09zM4.823 8.088a.93.93 0 1 0-1.86 0 .93.93 0 0 0 1.86 0zm9.911 4.646v4.337a.93.93 0 0 1-.929.929H6.371a.93.93 0 0 1-.93-.93v-4.336a.93.93 0 0 1 .93-.929h7.434a.93.93 0 0 1 .93.93z" />
                  </g>
                </g>
              </svg>
              <span v-if="!pdf_mergeing">{{ $t('page_2.page_2_3.detail_1.btn_1') }}</span>

              <div v-if="pdf_mergeing" class="elastic-wrapp">
                <div class="dot-elastic"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="spisi-right" v-if="multi_file_list.length > 0 && activityFile == null">
        <div class="detalji-spisa section">
          <div class="section-title">{{ $t('page_2.page_2_3.detail_4.title') }}
            <a @click="closeDetalji()" class="entry-exit"><img src="@/assets/img/entry_form_close.svg" /></a>
          </div>
          <div class="scroll-select-docs">
            <div class="detalji-spisa-top" v-for="(singleFile, key) in multi_file_list" :key="key">
              <img class="doc-icon" src="@/assets/img/default-icon.svg" />
              <div class="inside-folder-txts">
                <div class="inside-folder-title">{{ singleFile.name }}</div>
                <!-- <div class="detalji-spisa-tiny">
                    <span class="tezina">{{  (singleFile.size * 0.000001).toFixed(4)  }}MB</span>
                </div> -->
              </div>
            </div>
          </div>

          <!-- <div class="detalji-buttons detalji-buttons-tri" v-if="is_permission_inside('case.comunication.read')">
                <div class="print-button icon-button" @click="openSelectedFiles()">
                <svg id="SVGDoc" width="15" height="20" xmlns="http://www.w3.org/2000/svg" version="1.1"
                    xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:avocode="https://avocode.com/" viewBox="0 0 15 20">
                    <defs></defs>
                    <desc>Generated with Avocode.</desc>
                    <g>
                    <g>
                        <title>view_icon</title>
                        <path
                        d="M10.11096,14.23522c-0.55015,1.05848 -1.62709,1.72948 -2.80905,1.72948c-1.18184,0 -2.2589,-0.67099 -2.80905,-1.72948c0.55015,-1.05848 1.62721,-1.72948 2.80905,-1.72948c1.18196,0 2.2589,0.67099 2.80905,1.72948zM8.23807,14.23522c0,-0.52977 -0.41997,-0.96079 -0.93615,-0.96079c-0.51618,0 -0.93615,0.43103 -0.93615,0.96079c0,0.52977 0.41997,0.96079 0.93615,0.96079c0.51618,0 0.93615,-0.43103 0.93615,-0.96079zM14.60384,5.39586v12.87476c0,0.95358 -0.75591,1.72935 -1.68502,1.72935h-11.23381c-0.92912,0 -1.68502,-0.77577 -1.68502,-1.72935v-16.52582c0,-0.95358 0.75591,-1.72935 1.68502,-1.72935h7.86364c0.15295,0 0.29933,0.06399 0.40519,0.17716l4.49359,4.80409c0.10037,0.10726 0.1564,0.25033 0.1564,0.39916zM11.24929,14.46601c0.0627,-0.14713 0.0627,-0.31445 0,-0.46158c-0.68569,-1.6108 -2.23517,-2.65158 -3.94738,-2.65158c-1.7122,0 -3.26157,1.04078 -3.94738,2.65158c-0.06258,0.14713 -0.06258,0.31445 0,0.46158c0.68581,1.6108 2.23517,2.65158 3.94738,2.65158c1.7122,0 3.26169,-1.04078 3.94738,-2.65158zM12.3571,6.54889c0,-0.31838 -0.25141,-0.57658 -0.56171,-0.57658h-2.80833v-2.88237c0,-0.31838 -0.25153,-0.57645 -0.56171,-0.57645c-0.31018,0 -0.56171,0.25806 -0.56171,0.57645v3.45895c0,0.31838 0.25153,0.57645 0.56171,0.57645h3.37005c0.3103,0 0.56171,-0.25806 0.56171,-0.57645z"
                        fill="#2b2b41" fill-opacity="1"></path>
                    </g>
                    </g>
                </svg>
                {{ $t('billing_management.general_naplata.open') }}
                </div>
            </div> -->
        </div>
      </div>
      <div class="spisi-right" v-if="activityFile != null && activityFile.folder_name == undefined">
        <div class="detalji-spisa section">
          <div class="section-title">{{ $t('page_2.page_2_3.detail_2.title') }}
            <a @click="closeDetalji()" class="entry-exit"><img src="@/assets/img/entry_form_close.svg" /></a>
          </div>
          <div class="detalji-spisa-top">
            <img class="doc-icon" src="@/assets/img/default-icon.svg" />
            <div class="inside-folder-txts">
              <div class="inside-folder-title">{{ activityFile.name }}</div>
              <div class="detalji-spisa-tiny">
                <!-- <span class="tezina">{{ (activityFile.size * 0.000001).toFixed(4) }}MB</span> -->
              </div>
            </div>
          </div>
          <div class="detalji-spisa-list">
            <div class="detalji-spisa-middle">
              <div class="case-info-item">
                <div class="case-info-item-title">{{ $t('page_2.page_2_3.detail_2.tl_1') }}</div>
                <div class="case-info-item-info">
                  {{ switchDate(activityFile.time_created) }}
                </div>
              </div>
              <div class="case-info-item">
                <div class="case-info-item-title">{{ $t('page_2.page_2_3.detail_2.tl_2') }}:</div>
                <div class="case-info-item-info">
                  {{ getOdvjetnikName(activityFile.created_by) }}
                </div>
              </div>
              <div class="case-info-item">
                <div class="case-info-item-title">{{ $t('page_2.page_2_3.detail_2.tl_3') }}:</div>
                <div class="case-info-item-info">
                  {{ getOdvjetnikName(activityFile.edited_by) }} ({{
                      switchDate(activityFile.time_updated)
                  }})
                </div>
              </div>
              <div class="case-info-item">
                <div class="case-info-item-title">{{ $t('page_2.page_2_7.detail_document.tl_4') }}:</div>
                <div class="case-info-item-info">
                  {{ getTarget() }}
                </div>
              </div>
              <div class="case-info-item">
                <div class="case-info-item-title">{{ $t('page_2.page_2_7.detail_document.tl_5') }}:</div>
                <div class="case-info-item-info">
                  {{ activityFile.billing_types.naziv }}
                  <span v-if="activityFile.billing_types.id == 4" @click="openBreakdown()">&nbsp;-&nbsp;<span class="breakdown-link" >{{ $t('page_2.page_2_7.detail_document.breakdown') }}</span></span>
                </div>
              </div>
            </div>
          </div>
          <div class="detalji-buttons detalji-buttons-tri">
            <div class="print-button icon-button" v-if="is_permission_inside('case.comunication.read')"
              @click="openFile()">
              <svg id="SVGDoc" width="15" height="20" xmlns="http://www.w3.org/2000/svg" version="1.1"
                xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:avocode="https://avocode.com/" viewBox="0 0 15 20">
                <defs></defs>
                <desc>Generated with Avocode.</desc>
                <g>
                  <g>
                    <title>view_icon</title>
                    <path
                      d="M10.11096,14.23522c-0.55015,1.05848 -1.62709,1.72948 -2.80905,1.72948c-1.18184,0 -2.2589,-0.67099 -2.80905,-1.72948c0.55015,-1.05848 1.62721,-1.72948 2.80905,-1.72948c1.18196,0 2.2589,0.67099 2.80905,1.72948zM8.23807,14.23522c0,-0.52977 -0.41997,-0.96079 -0.93615,-0.96079c-0.51618,0 -0.93615,0.43103 -0.93615,0.96079c0,0.52977 0.41997,0.96079 0.93615,0.96079c0.51618,0 0.93615,-0.43103 0.93615,-0.96079zM14.60384,5.39586v12.87476c0,0.95358 -0.75591,1.72935 -1.68502,1.72935h-11.23381c-0.92912,0 -1.68502,-0.77577 -1.68502,-1.72935v-16.52582c0,-0.95358 0.75591,-1.72935 1.68502,-1.72935h7.86364c0.15295,0 0.29933,0.06399 0.40519,0.17716l4.49359,4.80409c0.10037,0.10726 0.1564,0.25033 0.1564,0.39916zM11.24929,14.46601c0.0627,-0.14713 0.0627,-0.31445 0,-0.46158c-0.68569,-1.6108 -2.23517,-2.65158 -3.94738,-2.65158c-1.7122,0 -3.26157,1.04078 -3.94738,2.65158c-0.06258,0.14713 -0.06258,0.31445 0,0.46158c0.68581,1.6108 2.23517,2.65158 3.94738,2.65158c1.7122,0 3.26169,-1.04078 3.94738,-2.65158zM12.3571,6.54889c0,-0.31838 -0.25141,-0.57658 -0.56171,-0.57658h-2.80833v-2.88237c0,-0.31838 -0.25153,-0.57645 -0.56171,-0.57645c-0.31018,0 -0.56171,0.25806 -0.56171,0.57645v3.45895c0,0.31838 0.25153,0.57645 0.56171,0.57645h3.37005c0.3103,0 0.56171,-0.25806 0.56171,-0.57645z"
                      fill="#2b2b41" fill-opacity="1"></path>
                  </g>
                </g>
              </svg>
              {{ $t('page_2.page_2_7.detail_document.btn_1') }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import auth from "@/services/auth";
import $ from "jquery";
import gsap from "gsap";
import TreeMenu from "@/components/generalComponents/DBTreeMenu.vue";
import moment from "moment";
import CaseTab from "@/components/caseComponents/CaseTab.vue";
import draggable from "vuedraggable";
import financial from "@/apiCallers/promise_handler_db/financial.js";
import permissioner from "@/services/permissioner.js"
import { getCaseData } from "@/router/case/handler"
import DataLoader from '@/components/generalComponents/DataLoader'
import predmet_hand from "@/apiCallers/promise_handler_db/predmeti";
import CustomDropdown from "@/components/generalComponents/CustomDropdown.vue";
import CustomSpinner from "@/components/generalComponents/CustomSpinner.vue";

const end_curr_month = moment().endOf("month").format("YYYY-MM-DD");
const begin_date = moment().subtract(1,"year").startOf("month").format("YYYY-MM-DD")
const predefined_start_span = [begin_date,end_curr_month]
export default {
  components: {
    TreeMenu,
    draggable,
    CaseTab,
    DataLoader,
    CustomDropdown,
    CustomSpinner
  },
  data() {
    return {
      targetirane_skupine: this.$t('page_2.page_2_7.targetirane_skupine'),
      //moving 
      destination_folder: null,
      //upload folder start
      newDirectoryName: "",
      newDirectoryParentId: "",
      newFolderPop: false,
      uploadNode: null,
      //upload folder end
      overlay_progress: 0,
      popis_preuzimanja_spisa: [],
      upload_fold_model: false,
      selected_upload_folder: null,
      order_by_tekst: this.$t('page_2.page_2_7.f_asc'),
      side_spis_view: false,
      selected_spis: {},
      smjer: false,
      delete_screen: false,
      trigg: true,
      activityFile: null,
      multi_file_list: [],
      tree: {},
      accessToken: "",
      loading: false,
      selectedFolder: null,
      selectedFile: "",
      progress: 0,
      folders: [],
      predmet_info: { broj_predmeta: '' },
      rootSpisi: [],
      filelist: [],

      mapped_case_permission: [],
      snackbar: false,
      snackTimeout: 10000,
      odbacene: [],
      snackText: '',
      //ulazna i izlazna pošta
      input_mail_id: "",
      output_mail_id: "",
      chosen_type: 0,
      is_waiting_on_insert: false,
      active_mail_type: "",

      all_files_rec: null,
      are_files_loaded: false,
      refresher: 1,

      new_file_name: "",
      renameFilePop: false,


      permission: {
        create: true,
        update: true,
        delete: true,
        read: true
      },
      folder_name: '',
      anim_duration: 0.5,
      overlay_thumbnail: false,
      snackbar_move: false,
      troskovnici_data: [],
      delete_forbidden: false,
      all_odvjetnici: [],
      created_from_fileid: null,
      menu1: false,
      date_range: predefined_start_span,
      pickerDate: null,
      first_open: true,
      selektirani_tip: 0,
      selektirana_osoba: 0,
      selektirani_tip_foldera: 0,
      filter_type: this.$t("billing_page.filter_type"),
      all_doc_types: this.$t("billing_page.all_doc_types"),
      sort_type: 1,
      pdf_mergeing: false,
      all_troskovnici: [],
      first_load: true,
    };
  },
  async created() {
    this.accessToken = this.$store.state.aToken
    await predmet_hand.getAllOdvjetniciShort().then((resp) => {
      this.all_odvjetnici = resp.data;
      this.all_odvjetnici.unshift({ id: 0, naziv: this.$t('billing_page.filters.f3') })
    });
    await this.refreshFilesTree();
  },
  computed: {
    dateRangeText: {
      get() {
        var ret_date_string = [];
        this.date_range.forEach((p) => {
          ret_date_string.push(moment(p).format("l"));
        });
        return ret_date_string.join(" ~ ");
      },
      set(new_val) {
        // console.log(new_val)
        if (new_val == null) {
          this.date_range = [];
        }
      }
    },
  },
  watch: {
    pickerDate: function () {
      let is_same_month = false;
      console.log(this.date_range,"Date range watch")
      if (this.date_range.length == 2)
        is_same_month = (moment(this.date_range[0]).month() == moment(this.date_range[1]).month())
      else if (this.date_range.length == 0)
        is_same_month = true

      if (!this.first_open && is_same_month) {
        let listed_date = []
        listed_date.push(moment(this.pickerDate).startOf("month").format("YYYY-MM-DD"));
        listed_date.push(moment(this.pickerDate).endOf("month").format("YYYY-MM-DD"));
        this.date_range = listed_date
        // console.log(listed_date)
      } else
        this.first_open = false
    },
    selektirani_tip: function () {
      this.refreshFilesTree();
    },
    date_range: function () {
      console.log(predefined_start_span,"Date range watch")

      this.refreshFilesTree();
    },
    selektirana_osoba: function () {
      this.refreshFilesTree();
    },
    selektirani_tip_foldera: function () {
      this.refreshFilesTree();
    },
  },
  methods: {
    getFolderName(name) {
      switch (name.trim()) {
        case "Ulazni dokumenti":
        case "Ulazna pošta":
            return this.$t('page_2.page_2_5.fold_1');
        case "Izlazni dokumenti":
        case "Izlazna pošta":
            return this.$t('page_2.page_2_5.fold_2'); 
        case "Radni dokumenti":
            return this.$t('page_2.page_2_4.fold_2'); 
        case "Popratni dokumenti":
            return this.$t('page_2.page_2_4.fold_3');
        case "Naplata":
            return this.$t('page_2.page_2_7.fold_1');
        case "Računi":
            return this.$t('page_2.page_2_7.fold_2');
        case "Troškovnici":
            return this.$t('billing_page.all_doc_types[1].naziv');
        case "Troškovnici":
            return this.$t('billing_page.all_doc_types[1].naziv');
        case "Nalozi za fakturiranje":
            return this.$t('billing_page.all_doc_types[2].naziv');
        case "Ostalo":
            return this.$t('billing_page.all_doc_types[3].naziv');
        default:
            return name;
      }
    },
    switchTab(nastavak) {
      this.$router.push("/" + nastavak);
    },
    async openReport() {

      this.$store.state.naplata_report_data.all_troskovnici = this.all_troskovnici;
      this.$router.push('/naplata-report');
    },
    openBreakdown(){
      this.$store.state.breakdown_report_data = {
        breakdown:this.activityFile.breakdown_satnice,
        predmet_data:this.activityFile.predmet,
        punomocnik:this.activityFile.edit_structure.punomoćnik_osoba,
        naziv_dokumenta: this.activityFile.edit_structure.name,
      }
      this.$router.push('/breakdown-report')
    },
    async troskovniciToPDF() {
      var start_date = null;
      var end_date = null;
      let sorted_date_range = [...this.date_range]
      sorted_date_range.sort((a, b) => new Date(a) - new Date(b))
      if (sorted_date_range.length > 0) {
        start_date = sorted_date_range[0];
        if (sorted_date_range.length > 1) {
          end_date = sorted_date_range[1];
        }
        else {
          end_date = sorted_date_range[0];
        }
      }
      this.pdf_mergeing = true;
      await financial.printAllTroskovnici(this.activityFile.id_folder, this.selektirani_tip, start_date, end_date, this.selektirana_osoba, this.selektirani_tip_foldera).then(async (resp) => {
        console.log(resp);
        var newBlob = new Blob([resp.data], {
          type: "application/pdf",
        });
        var data = window.URL.createObjectURL(newBlob);

        var link = document.createElement("a");
        link.href = data;
        link.download = "troskovnik-" + moment().format("l") + ".pdf";
        link.click();
        setTimeout(function () {
          // For Firefox it is necessary to delay revoking the ObjectURL
          window.URL.revokeObjectURL(data);
        }, 100);
      }).finally(() => {
        this.pdf_mergeing = false;
      });
    },
    openFile() {
      this.$store.state.troskovnik_pdf_view = true;
      this.$store.state.troskovnik_data = this.activityFile.recreate_pdf_structure;
      this.$router.push('/troskovnik-report')
    },
    getTarget() {
      return this.targetirane_skupine.find((sk) => sk.id == this.activityFile.edit_structure.targetirana_skupina.ID).naziv;
    },
    getOdvjetnikName(uid) {
      return this.all_odvjetnici.find((od) => od.id == uid).naziv;
    },
    async refreshFilesTree() {
      this.closeDetalji();
      var start_date = null;
      var end_date = null;
      let sorted_date_range = [...this.date_range]
      sorted_date_range.sort((a, b) => new Date(a) - new Date(b))
      if (sorted_date_range.length > 0) {
        start_date = sorted_date_range[0];
        if (sorted_date_range.length > 1) {
          end_date = sorted_date_range[1];
        }
        else {
          end_date = sorted_date_range[0];
        }
      }
      await financial.getAllTroskovnici(this.smjer, this.selektirani_tip, start_date, end_date, this.selektirana_osoba, this.sort_type, this.selektirani_tip_foldera).then(async (resp) => {
        // console.log(resp.data);
        this.troskovnici_data =resp.data.tree;
        this.all_troskovnici = resp.data.all_case_troskovnici;

        // console.log(this.$route.query.file_id)
        // console.log(this.all_troskovnici)
        if (this.first_load && this.$route.query.file_id != undefined) {
          this.activityFile = this.all_troskovnici.reverse().find(p => p.id_troskovnik = this.$route.query.file_id)
          this.first_load = false;

        }


        if ($('#tree-menu').height() > 960) {
          this.anim_duration = 0.4;
        }
        else {
          this.anim_duration = $('#tree-menu').height() * 0.00045;
        }
        gsap.fromTo('#tree-menu', this.anim_duration, { height: 0 }, { height: 'auto', ease: "none" });
        $('.fold-to-click').removeClass("hovered-folder")
        $('.inside-folder').removeClass("eye_clicked")
        this.are_files_loaded = true;
      });
    },
    closeDetalji() {
      this.activityFile = null;
      this.multi_file_list = [];
      $('.inside-folder').removeClass("eye_clicked");
    },
    is_permission_inside(wanted_permission, assistent_check = true) {
      return permissioner.check_case_permsision(wanted_permission)
    },
    folderHover(node) {
      if (node == null) {
        this.destination_folder = null
      } else {
        this.destination_folder = node;
      }
    },
    reverseSmjer(id_filter) {
      // aktiviraj filter
      if (id_filter == 0) {
        //filter naziva
        $('#name-filter').addClass("active");
        $('#date-filter').removeClass("active");


      } else {
        // filter datuma  
        $('#date-filter').addClass("active");
        $('#name-filter').removeClass("active");
      }




      // TweenMax.to('.open-folder-line-sort svg', 1, {rotation:360, ease:Linear.easeNone, repeat:-1})
      if ($('#tree-menu').height() > 960) {
        this.anim_duration = 0.4;
      }
      else {
        this.anim_duration = $('#tree-menu').height() * 0.00045;
      }

      // gsap.fromTo('#tree-menu',this.anim_duration,{height:0},{height:'auto', ease: "none"});
      gsap.to('#tree-menu', this.anim_duration, { height: 0, ease: "none" });
      setTimeout(async () => {
        if (id_filter == this.sort_type) {
          this.smjer = !this.smjer;
          if (this.smjer) {
            gsap.to('.svg-to-rotate', 0, { rotation: 0 });
            this.order_by_tekst = this.$t("page_2.page_2_3.f_desc");
          } else {
            gsap.to('.svg-to-rotate', 0, { rotation: 180 });
            this.order_by_tekst = this.$t("page_2.page_2_3.f_asc");
          }
        } else {
          this.sort_type = id_filter
        }

        await this.refreshFilesTree();
        gsap.fromTo('#tree-menu', this.anim_duration, { height: 0 }, { height: 'auto', ease: "none" });
      }, this.anim_duration * 1000);
    },
    logClick(node) {
      this.activityFile = node;
      this.multi_file_list = [];
      this.multi_file_list.push(node)
      // this.getPreview();
      this.side_spis_view = false;
      //animacija za detalje spisa - da se signalizira da se nešto promijenilo
      gsap.fromTo(".detalji-spisa", 0.3, { y: 50 }, { y: 0 });
    },
    setMultiFileSelection(node) {
      this.activityFile = null;
      // this.getPreview();
      this.side_spis_view = true;
      //animacija za detalje spisa - da se signalizira da se nešto promijenilo
      gsap.fromTo(".detalji-spisa", 0.3, { y: 50 }, { y: 0 });

      let tmp_index = this.multi_file_list.findIndex((p) => {
        return p.id_troskovnik == node.id_troskovnik;
      });
      if (tmp_index == -1) {
        console.log("Datoteka nije u popisu ", tmp_index)
        this.multi_file_list.push(node);
      } else {
        console.log("Datoteka je u popisu ", this.multi_file_list,)
        $('#single-file-' + node.id).removeClass("eye_clicked");
        this.multi_file_list.splice(tmp_index, 1);
      }

    },

    // CREATE FOLDER FUNCTIONS START
    handleFolderCreateFromFile(node) {
      console.log(node);
      this.newDirectoryName = node.name;
      this.newFolderPop = true;
      this.newDirectoryParentId = node.parent_id;
      this.created_from_fileid = node.id_troskovnik;
      this.is_from_file = true;
    },
    //CREATE NEW FOLDER WHEN CLICKED ON ANOTHER FOLDER
    handleFolderCreateFromFolder(node) {
      this.newDirectoryName = "";
      this.newFolderPop = true;
      this.newDirectoryParentId = node.id_folder;
    },
    //APPROPRIATE DATE TIME FORMAT FOR DISPLAY
    switchDate(inData) {
      return moment(inData.toString()).format("lll");
    },
  },
  mounted() {
    this.$store.state.paginacija.title = this.$t("breadcrumbs.general_naplata");
    //za hendlanje desnog spis detalji prozorčića
    setTimeout(function () {
      $(window).scroll(function () {
        var brojDokumenata = $(".spis-megawrapper").length;
        var h = document.documentElement,
          b = document.body,
          st = "scrollTop",
          sh = "scrollHeight";
        var percent =
          ((h[st] || b[st]) / ((h[sh] || b[sh]) - h.clientHeight)) * 100;
        if (percent > 20 || window.matchMedia("(min-width: 1199px) and (max-width: 1570px)").matches) {
          gsap.to(".spisi-right", 0.3, { marginTop: "-12rem" });
        }
        if (percent < 20) {
          gsap.to(".spisi-right", 0.3, { marginTop: "7.2rem" });
        }
      }); //end scroll function
    }, 1700);
  },
  destroyed() {
    setTimeout(() => {
      $(window).off();
    }, 1700);
  },
};
</script>